import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class LoginFormService {
  public transformErrorMessages(form: FormGroup): string[] {
    let errorMessage: string[] = [];
    for (const field of Object.keys(form.controls)) {
      const errors = form.get(field).errors;
      if (!errors) {
        continue;
      }

      Object.keys(errors).forEach((errorKey: string) => {
        switch (errorKey) {
          case 'matchPassword':
          case 'matchPasswords':
            errorMessage = ['password.not.match'];
            break;
          case 'email':
            errorMessage = ['customerreg.message.validemail'];
            break;
          case 'minlength':
          case 'passwordSpecialCharacters':
            errorMessage = [
              'change-password.string2',
              'change-password.string3',
              'change-password.string4',
              'change-password.string5',
              'change-password.string6'
            ];
        }
      });
    }

    return errorMessage;
  }
}
